/**
 * Mobile Navigation functionality
 */

document.addEventListener("DOMContentLoaded", () => {
	// Move modals to the end of body (portal behavior)
	const modalPortals = document.querySelectorAll(
		"[data-wpb-navigation-portal]",
	);
	modalPortals.forEach((modal) => {
		document.body.appendChild(modal);
	});

	// Pair each toggle with its modal once, avoiding repeated lookups later
	const pairs = Array.from(
		document.querySelectorAll(".wpb-navigation-toggle"),
	)
		.map((toggle) => {
			const modal = document.getElementById(
				toggle.getAttribute("aria-controls"),
			);

			return modal ? { toggle, modal } : null;
		})
		.filter(Boolean);

	const modalToToggle = new Map(pairs.map(({ toggle, modal }) => [modal, toggle]));

	const openNavigation = (toggle, modal) => {
		toggle.setAttribute("aria-expanded", "true");
		toggle.classList.add("is-active");
		modal.setAttribute("aria-hidden", "false");
		modal.classList.add("is-open");
		document.body.classList.add("wpb-navigation-modal-open");
	};

	const closeNavigation = (toggle, modal) => {
		toggle.setAttribute("aria-expanded", "false");
		toggle.classList.remove("is-active");
		modal.setAttribute("aria-hidden", "true");
		modal.classList.remove("is-open");
		document.body.classList.remove("wpb-navigation-modal-open");
	};

	const closeAllOpenModals = () => {
		pairs.forEach(({ toggle, modal }) => {
			if (modal.classList.contains("is-open")) {
				closeNavigation(toggle, modal);
			}
		});
	};

	// Handle mobile menu toggle
	pairs.forEach(({ toggle, modal }) => {
		toggle.addEventListener("click", (e) => {
			e.preventDefault();

			const isExpanded = toggle.getAttribute("aria-expanded") === "true";

			if (isExpanded) {
				closeNavigation(toggle, modal);
			} else {
				openNavigation(toggle, modal);
			}
		});
	});

	// Handle close buttons
	document.querySelectorAll(".wpb-navigation-close").forEach((closeBtn) => {
		closeBtn.addEventListener("click", (e) => {
			e.preventDefault();

			const modal = closeBtn.closest(".wpb-navigation-modal");
			const toggle = modalToToggle.get(modal);

			if (toggle && modal) {
				closeNavigation(toggle, modal);
			}
		});
	});

	// Handle submenu toggles
	document
		.querySelectorAll(".wpb-navigation-submenu-toggle")
		.forEach((toggle) => {
			toggle.addEventListener("click", (e) => {
				e.preventDefault();

				const isExpanded = toggle.getAttribute("aria-expanded") === "true";
				const parentItem = toggle.closest(".wpb-navigation-item");

				toggle.setAttribute("aria-expanded", !isExpanded);
				parentItem.classList.toggle("submenu-open");
			});
		});

	// Close modal when clicking outside
	pairs.forEach(({ toggle, modal }) => {
		modal.addEventListener("click", (e) => {
			if (e.target === modal) {
				closeNavigation(toggle, modal);
			}
		});
	});

	// Close modal on escape key
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") {
			closeAllOpenModals();
		}
	});

	// Close modal when the viewport grows past the desktop breakpoint
	const desktopBreakpoint = window.matchMedia("(min-width: 1200px)");

	desktopBreakpoint.addEventListener("change", (e) => {
		if (e.matches) {
			closeAllOpenModals();
		}
	});
});
